import React from "react";
import PropTypes from "prop-types";
import GroupPropType from "src/custom-prop-types/group";
import ConfiguredActionMenu from "src/components/ConfiguredActionMenu";
import useTeamActions from "./hooks/useTeamActions";

const TeamDetailsActionMenu = ({
  team,
  showInsightIcon = true,
  actionMenuTypes,
  direction = "left-start",
  runGroupCacheUpdateOnAddition = true,
  showChangesEnabled,
  onChangeDetailsClick,
}) => {
  const actions = useTeamActions({
    team,
    actionMenuTypes,
    showChangesEnabled,
    onChangeDetailsClick,
    runGroupCacheUpdateOnAddition,
  });

  return (
    <ConfiguredActionMenu
      direction={direction}
      ml="r"
      className="guided-tour-team-details-view-actions-menu"
      data-testid="cp-team-details-action-menu"
      actions={actions}
      team={team}
      showInsightIcon={showInsightIcon}
    />
  );
};

TeamDetailsActionMenu.propTypes = {
  team: GroupPropType.isRequired,
  showInsightIcon: PropTypes.bool,
  actionMenuTypes: PropTypes.arrayOf(PropTypes.string),
  direction: PropTypes.string,
  runGroupCacheUpdateOnAddition: PropTypes.bool,
  showChangesEnabled: PropTypes.bool,
  onChangeDetailsClick: PropTypes.func,
};

export default TeamDetailsActionMenu;
